import axios from '../../axiosInstance';

class DadosExameService {
  async buscarListaCodigosExame() {
    return await axios.get('/relacionamentoExames/', {
      params: {
        apenasExamesRelacionados: true
      }
    });
  }

  async listaExames(termo, ehVeterinario, material) {
    return await axios.get('/exames/termo', {
      params: {
        ehVeterinario: ehVeterinario,
        material: material,
        termo: termo
      }
    });
  }

  async obterExame(mnemonico, material) {
    return await axios.get('/exames/mnemonico/material', {
      params: {
        mnemonico: mnemonico,
        material: material
      }
    });
  }

  async listarMateriais(mnemonico, material) {
    return await axios.get('/materiais', {
      params: {
        mnemonico: mnemonico,
        material: material
      }
    });
  }

  async listarConservantes(mnemonico, mnemonicoMaterial, codigoMaterial) {
    return await axios.get('/conservantes', {
      params: {
        mnemonico: mnemonico,
        mnemonicoMaterial: mnemonicoMaterial,
        codigoMaterial: codigoMaterial
      }
    });
  }

  async listarExamesContratoLicitacao(codigoContrato) {
    return await axios.get(`contratoLicitacao/${codigoContrato}/dadosExames`);
  }
}

export default new DadosExameService();